module.exports = __webpack_public_path__ + "static/media/2023.9.11_fairearth_brandmark_gold.1b980b84.png";